import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MAJOR_PARTNERS, MajorPartner } from '@domains/home/major-partners/partners';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';

@Component({
  selector: 'app-home-major-partners',
  templateUrl: './major-partners.component.html',
  styleUrls: ['./major-partners.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MajorPartnersComponent {
  MAJOR_PARTNERS = MAJOR_PARTNERS;

  FeaturesRoutingEnum = FeaturesRoutingEnum;

  trackByPartnerId(_: number, partner: MajorPartner): string {
    return partner.id;
  }
}

@NgModule({
  imports: [CommonModule, RouterModule, ImaginarySrcModule],
  declarations: [MajorPartnersComponent],
  exports: [MajorPartnersComponent],
})
export class MajorPartnersModule {}
